import React from 'react';
import { blogcastShows, getBlogcastShow, BLOGCAST_HUB } from '../data/blogcastShows';

const SITE = 'https://bwgela.com';
const isoDur = (s) => `PT${Math.floor((s || 0) / 60)}M${Math.round((s || 0) % 60)}S`;

const buildLd = (show, episodes, api) => {
  const crumbs = [
    { '@type': 'ListItem', position: 1, name: 'Home', item: SITE },
    { '@type': 'ListItem', position: 2, name: 'Blogcast', item: `${SITE}/blogcast` },
  ];
  if (!show) {
    return [
      { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: crumbs },
      {
        '@context': 'https://schema.org', '@type': 'ItemList', name: 'The BWGELA Blogcast',
        itemListElement: blogcastShows.map((s, i) => ({
          '@type': 'ListItem', position: i + 1,
          item: { '@type': 'PodcastSeries', name: s.title, url: `${SITE}/blogcast/${s.slug}`, image: s.cover, description: s.description },
        })),
      },
    ];
  }
  const url = `${SITE}/blogcast/${show.slug}`;
  return [
    { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: [...crumbs, { '@type': 'ListItem', position: 3, name: show.title, item: url }] },
    {
      '@context': 'https://schema.org', '@type': 'PodcastSeries', name: `${show.title} | The BWGELA Blogcast`, url,
      image: show.cover, description: show.description, inLanguage: 'en-GB',
      author: { '@type': 'Organization', name: 'BWGELA', url: SITE },
      episode: episodes.slice(0, 60).map((e) => ({
        '@type': 'PodcastEpisode', name: e.title, episodeNumber: e.episode_number, url: `${url}?ep=${e.episode_number}`,
        datePublished: (e.published_at || '').slice(0, 10) || undefined, timeRequired: isoDur(e.duration),
        associatedMedia: { '@type': 'MediaObject', contentUrl: `${api}${e.audio_url}`, encodingFormat: 'audio/mpeg' },
      })),
    },
  ];
};

export const BlogcastSeo = ({ slug, episodes = [] }) => {
  const show = slug ? getBlogcastShow(slug) : null;
  const title = show ? show.seoTitle : BLOGCAST_HUB.title;
  const description = show ? show.description : BLOGCAST_HUB.description;
  const url = show ? `${SITE}/blogcast/${show.slug}` : `${SITE}/blogcast`;
  const image = show ? show.cover : blogcastShows[0].cover;
  const ld = buildLd(show, episodes, process.env.REACT_APP_BACKEND_URL);
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="BWGELA" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {ld.map((o, i) => <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(o) }} />)}
    </>
  );
};

export default BlogcastSeo;
